import {SetStateAction} from "react";

export default function disconnectHandler(setIsConnectedHandler: SetStateAction<any>) {
    return (event: Event) => {
        setIsConnectedHandler(false);
    };
}